import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

//Importing Modal
// import ModalSection from '../../components/common/ModalSection';

//Import Image
// import img1 from "../../assets/images/bg-home.jpg";

class Section extends Component {
	constructor() {
		super();
		this.state = {
			isOpen: false,
			height: window.innerHeight,
			device: '',
		};
		this.setFullScreen.bind(this);
	}

	setFullScreen = () => {
		var topSectionEl = document.getElementById('home-fullscreen');
		if (topSectionEl.clientHeight > 0) {
			var windowHeight = window.innerHeight;
			this.setState({
				height: windowHeight,
			});
		}
	};

	UNSAFE_componentDidMount() {
		this.setFullScreen();
		window.addEventListener('resize', this.setFullScreen);
	}

	UNSAFE_componentWillUnmount() {
		window.addEventListener('resize', this.setFullScreen);
	}

	render() {
		return (
			<React.Fragment>
				<section className="home bg-home" id="home">
					<Container>
						<Row>
							<Col md="12">
								<div
									className="home-fullscreen"
									id="home-fullscreen"
									style={{ height: this.state.height + 'px' }}
								>
									<div className="full-screen">
										<div
											style={{
												display: 'flex',
												position: 'relative',
												flexDirection: 'column',
												height: '100vh',
												borderRadius: '8px',
												alignItems: 'center',
												justifyContent: 'center',
												textAlign: 'center',
												color: '#ffffff',
												zIndex: '2',
											}}
										>
											<h1>
												<span>Innovative Software Solutions</span>
											</h1>
											<h3
												className="font-3"
												style={{
													marginTop: '3.5rem',
													marginBottom: '1.5rem',
												}}
											>
												At Palm IT Systems we strive to include cutting edge
												technology in all of our services.
											</h3>
											<h3 className="font-3" style={{ marginBottom: '5rem' }}>
												We offer state of the art solutions to remain competitve
												on the Global stage.
											</h3>
										</div>

										{/* <Link to="" className="btn btn-custom">
														Learn more
													</Link>
													</Link> */}
									</div>
								</div>
							</Col>
						</Row>
						{/* Render ModalSection Component for Modal */}
						{/* <ModalSection ref="child" channel="vimeo" videoId="99025203" /> */}
					</Container>
				</section>
			</React.Fragment>
		);
	}
}

export default Section;
